export const warnIf = (condition: unknown, message: string) => {
  if (condition) {
    console.warn(message);
  }
};

export default null; // silence a false warning
